import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Dialog, Typography } from '@totalsoft/rocket-ui';
import { DialogActionsContainer } from '../DialogStyles';

const YesNoDialog = ({ id, title, content, onClose, onConfirm, open }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      id='yes-no-dialog'
      open={open}
      onClose={onClose}
      aria-labelledby={`${id}-dialog-display-title`}
      title={<Typography fontWeight='bold'>{title}</Typography>}
      maxWidth={'xs'}
      content={content}
      actions={
        <DialogActionsContainer>
          <Button autoFocus variant='contained' onClick={onConfirm}>
            {t('General.Yes')}
          </Button>
          <Button variant='contained' onClick={onClose}>
            {t('General.No')}
          </Button>
        </DialogActionsContainer>
      }
    />
  );
};

YesNoDialog.propTypes = {
  id: PropTypes.string,
  open: PropTypes.bool,
  title: PropTypes.string,
  content: PropTypes.node,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};

export default YesNoDialog;
